import xmlParser from "fast-xml-parser";

const DmeFileTypes = {
  REM_DTA_V1: "rem_dta_v1",
  QUALIPOOL_DtaVka_V1: "qualipool_dtavka_v1"
};

class TypeDetector {
  /** @type {string} */
  type = undefined;
  /** @type {object} */
  parsed = undefined;

  /**
   * @param {string} content
   */
  constructor(content) {
    this.detectType(content);
  }

  /**
   * @returns {string}
   */
  getType() {
    return this.type;
  }

  /**
   * @returns {Object}
   */
  getParsed() {
    return this.parsed;
  }

  /**
   * @param {string} string
   * @returns {string}
   */
  detectType(string) {
    const json = this.parseJson(string);
    if (json) {
      this.parsed = json;
      this.type = this.detectFromJson(json);
    }

    const xml = this.parseXml(string);
    if (xml) {
      this.parsed = xml;
      this.type = this.detectFromXml(xml);
    }

    return undefined;
  }

  /**
   * @param string
   * @returns {null|object}
   */
  parseJson(string) {
    try {
      return JSON.parse(string);
    } catch (e) {
      return null;
    }
  }

  /**
   * @param string
   * @returns {null|object}
   */
  parseXml(string) {
    const options = {
      ignoreAttributes: false,
      arrayMode: true,
      parseNodeValue: false,
      parseAttributeValue: false
    };

    try {
      return xmlParser.parse(string, options, true);
    } catch (e) {
      return null;
    }
  }

  /**
   * @param {object} obj
   * @returns {null|string}
   */
  // eslint-disable-next-line no-unused-vars
  detectFromJson(obj) {
    return null; // no json data exchange defined currently
  }

  /**
   * @param {object} obj
   * @returns {null|string}
   */
  detectFromXml(obj) {
    if (
      obj?.["VkaDocument"]?.[0]?.["InterfaceName"] === "DTA-VKA" &&
      obj?.["VkaDocument"]?.[0]?.["InterfaceVersion"] === "1.0"
    ) {
      return DmeFileTypes.QUALIPOOL_DtaVka_V1;
    }

    if (
      obj?.["DTA_REM"]?.[0]?.["Header"]?.[0]?.["@_Type"] === "DTA_ERGEBNIS" &&
      obj?.["DTA_REM"]?.[0]?.["Header"]?.[0]?.["@_Version"] === "1.0"
    ) {
      return DmeFileTypes.REM_DTA_V1;
    }

    return null;
  }
}

export { TypeDetector, DmeFileTypes };
